export enum InstrumentCategory {
  DRUMS = 'Drums',
  BASS = 'Bass',
  MELODY = 'Melody',
  VOCALS = 'Vocals'
}

export const stemCategories = {
  [InstrumentCategory.DRUMS]: [
    'Drums',
    'Closed',
    'Percussion',
    'Snare',
    'Rim',
    'Kick',
    'Clap',
    'SFX',
    'Clave',
    'Cowbell',
    'Snap',
    'Closed',
    'Open',
    'Open Hat',
    'ClosedHat',
    'OpenHat',
    'Ride',
    'Crash',
    'Tom',
    'Timbales',
    'Bongos',
    'Shakers',
    'Tambourine',
    'Conga',
    'Djembe',
    'Perc'
  ],
  [InstrumentCategory.BASS]: ['Synth Bass', 'Bass Guitar', 'Bass', '808'],
  [InstrumentCategory.MELODY]: [
    'Pluck',
    'Pad',
    'Melody',
    'Lead',
    'Chords',
    'Synth',
    'Arp',
    'Analog',
    'Bell',
    'Stabs',
    'Brass Hit',
    'Trumpet',
    'Clarinet',
    'Saxophone',
    'Flugelhorn',
    'Flute',
    'Woodwind',
    'Brass',
    'Piano',
    'Organ',
    'Acoustic Guitar',
    'Electric Guitar',
    'Synth Guitar',
    'Bottle',
    'Cello',
    'SFX',
    'Synth Guitar',
    'Synth Keys'
  ],
  [InstrumentCategory.VOCALS]: [
    'Vocoder',
    'Female',
    'Male',
    'Spoken Word',
    'Phrases',
    'Vox',
    'Vocals'
  ]
}
